'use client';

import { useEffect } from 'react';

export function ClientEnhancer() {
  useEffect(() => {
    // Add animation class after the page loads
    document.documentElement.classList.add('js-enabled');
    document.querySelector('main')?.classList.add('js-animate');
    
    return () => {
      document.documentElement.classList.remove('js-enabled');
      document.querySelector('main')?.classList.remove('js-animate');
    };
  }, []);
  
  return null;
}